<template>
  <div class="enroll-student-upload-main"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <AppScrollbar style="height: 100%">
      <div class="main-cont">
        <div class="title">
          <div class="label">
            <i class="el-icon-upload2"></i>
            <span>选择照片导入方式</span>
          </div>
          <div v-if="noPhotoInfo"
               class="extra">
            <span v-if="noPhotoInfo.count">
              <span>无录取照片人数：</span><span>{{noPhotoInfo.count}}</span>
              <EnrollStudentUploadNoPhoto>
                <template #default="{toggleVisible}">
                  <el-button size="mini"
                             type="text"
                             @click="toggleVisible">点击查看</el-button>
                </template>
              </EnrollStudentUploadNoPhoto>
            </span>
            <span v-else>学生均已上传录取照片</span>
          </div>
        </div>
        <div class="select-cont">
          <el-select v-model="mode"
                     size="mini"
                     placeholder="请依据照片命名选择导入方式">
            <el-option label="身份证号"
                       value="idNo"/>
            <el-option label="学号"
                       value="regNo"/>
            <el-option label="学校代码+学号"
                       value="sRegNo"/>
          </el-select>
        </div>
        <div class="upload-cont">
          <DataUnpackModule :unpack-url="uploadUrl"
                            :pre-handle-params="uploadParams"
                            :pre-handle-verify="uploadVerify"
                            inline
                            @dataUnpackSuccess="loadNoPhotoInfo"></DataUnpackModule>
        </div>
      </div>
    </AppScrollbar>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../elements/AppScrollbar'
import DataUnpackModule from '../../../../../../elements/DataUnpackModule'
import EnrollStudentUploadNoPhoto from './no-photo'
export default {
  name: 'EnrollStudentUploadMain',
  components: {
    AppScrollbar,
    DataUnpackModule,
    EnrollStudentUploadNoPhoto
  },
  data () {
    return {
      uploadUrl: '/workspace/manager/enroll/upload/student/uploadPhoto',
      mode: '',
      loading: false,
      noPhotoInfo: null
    }
  },
  methods: {
    uploadParams () {
      return {
        mode: this.mode
      }
    },
    uploadVerify () {
      if (!this.mode) {
        this.$message.warning('请先选择导入方式')
        return
      }
      return true
    },
    loadNoPhotoInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enroll/upload/student/noPhoto/info',
        method: 'post'
      }).then(response => {
        if (response.data) {
          this.noPhotoInfo = response.data['noPhotoInfo'] || {}
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadNoPhotoInfo()
  },
  activated () {
    this.loadNoPhotoInfo()
  }
}
</script>

<style lang="scss">
  .enroll-student-upload-main {
    height: 100%;
    .main-cont {
      margin: 30px auto;
      width: 540px;
      max-width: 100%;
      & > .title {
        display: flex;
        justify-content: space-between;
        & > .label {
          font-size: 12px;
          i {
            margin-right: 4px;
            font-size: 15px;
            vertical-align: -1px;
          }
        }
        & > .extra {
          font-size: 12px;
          .el-button {
            margin-left: 5px;
            padding: 0;
          }
        }
      }
      & > .select-cont {
        margin-top: 15px;
        .el-select {
          width: 100%;
          .el-input__inner {
            border-radius: 0;
          }
        }
      }
      & > .upload-cont {
        margin-top: 15px;
      }
    }
  }
</style>
